<div class="table-container">
  <table mat-table [dataSource]="dataSource()" [multiTemplateDataRows]="expandableRows()">
    @for (column of columns(); track column) {
      @if (!column.useTemplate) {
        <ng-container [matColumnDef]="column.columnDef">
          <th mat-header-cell *matHeaderCellDef>
            {{ column.header }}
          </th>
          <td mat-cell *matCellDef="let row">
            {{ column.cell(row) }}
          </td>
        </ng-container>
      }
    }

    <ng-content></ng-content>

    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns().length">
        @if (expandedElement === row) {
          <div
            class="element-detail-wrapper"
            [class.element-detail-wrapper-expanded]="isExpanded(row)"
          >
            <ng-container
              *ngTemplateOutlet="
                expandedRowTemplate;
                context: { $implicit: row, toggleRow: toggle.bind(this) }
              "
            >
            </ng-container>
          </div>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns()"
      class="element-row"
      [class.expanded-row]="isExpanded(row)"
    ></tr>
    <tr *matNoDataRow>
      <td class="mat-cell" [colSpan]="displayedColumns().length">
        <div class="no-data-placeholder">No data</div>
      </td>
    </tr>
    <tr
      mat-row
      *matRowDef="let row; columns: ['expandedDetail']; when: isExpandableRows"
      class="detail-row"
    ></tr>
  </table>
</div>
@if (showPaginator()) {
  <mat-paginator
    [pageSizeOptions]="[5, 10, 25, 100]"
    [pageSize]="10"
    [length]="totalCount()"
    (page)="handlePageEvent($event)"
    showFirstLastButtons
  ></mat-paginator>
}
